module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-306.a3bb0f4.woff2";